import VehicleInventory, { VehicleInventorySkeleton } from "./VehicleInventory/VehicleInventory";
import VehicleShowroomWorks from "./VehicleShowroomWorks/VehicleShowroomWorks";
import { arrayMap } from "../../../utils/array.utils";
import VehicleCustomerRequirements from "./VehicleCustomerRequirements/VehicleCustomerRequirements";
import CardLayout from "../../../layouts/CardLayout";
import VehicleDeliveryReportChecking from "./VehicleDeliveryReportChecking/VehicleDeliveryReportChecking";
import VehicleDeliveryAck from "./VehicleDeliveryAck/VehicleDeliveryAck";
import VehicleDeliveryGreetings from "./VehicleDeliveryGreetings/VehicleDeliveryGreetings";
import VehicleDeliveryGift from "./VehicleDeliveryGift/VehicleDeliveryGift";
import VehicleAfterSaleServices from "./VehicleAfterSaleServices/VehicleAfterSaleServices";
import CardTitle from "../../../components/styled/CardTitle";
import Skeleton from "react-loading-skeleton";
import { getRandomNumber } from "../../../utils/number.utils";

export default function VehicleContent({ data, loading }) {
  const contents = [
    {
      id: 1,
      component: VehicleInventory,
      title: "Inventory"
    },
    {
      id: 2,
      component: VehicleShowroomWorks,
      title: "Showroom Condition Works"
    },
    {
      id: 3,
      component: VehicleCustomerRequirements,
      title: "Customer Requirements"
    },
    {
      id: 4,
      component: VehicleDeliveryReportChecking,
      title: "Delivery Report Checking"
    },
    {
      id: 5,
      component: VehicleDeliveryAck,
      title: "Delivery Acknowledgment"
    },
    {
      id: 6,
      component: VehicleDeliveryGreetings,
      title: "Delivery Greetings"
    },
    {
      id: 7,
      component: VehicleDeliveryGift,
      title: "Delivery Gifts"
    },
    {
      id: 8,
      component: VehicleAfterSaleServices,
      title: "After-Sale Services"
    }
  ];

  return (
    <div className="row g-3">
      {arrayMap(contents, (item) => {
        const Component = item.component;
        return (
          <div key={item.id} className="col-12">
            <CardLayout>
              <Component data={data} loading={loading}>
                <CardTitle>{item.title}</CardTitle>
              </Component>
            </CardLayout>
          </div>
        );
      })}
    </div>
  );
}

// skeleton
export function VehicleContentSkeleton() {
  const contents = [
    {
      id: 1,
      component: VehicleInventorySkeleton,
      title: "Inventory"
    },
    {
      id: 2,
      component: VehicleShowroomWorks,
      title: "Showroom Works"
    },
    {
      id: 3,
      component: VehicleCustomerRequirements,
      title: "Customer Requirements"
    },
    {
      id: 4,
      component: VehicleDeliveryReportChecking,
      title: "Delivery Report Checking"
    },
    {
      id: 5,
      component: VehicleDeliveryAck,
      title: "Delivery Acknowledgment"
    },
    {
      id: 6,
      component: VehicleDeliveryGreetings,
      title: "Delivery Greetings"
    },
    {
      id: 7,
      component: VehicleDeliveryGift,
      title: "Delivery Gifts"
    },
    {
      id: 8,
      component: VehicleAfterSaleServices,
      title: "After-Sale Services"
    }
  ];
  return (
    <div className="row g-3">
      {arrayMap(contents, (item) => {
        const Component = item.component;
        return (
          <div key={item.id} className="col-12">
            <CardLayout>
              <Component>
                <Skeleton width={`${getRandomNumber(30, 60)}%`} />
              </Component>
            </CardLayout>
          </div>
        );
      })}
    </div>
  );
}
